import { Box, IconButton, Typography, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FunctionComponent, ReactElement } from 'react';

const useStyles = makeStyles<Theme>((theme) => ({
  anchor: {
    marginLeft: theme.spacing(2),
  },
  button: {
    background: '#D9DBE9',
    height: theme.spacing(6),
    width: theme.spacing(6),
  },
}));

interface SocialCounterProps {
  label: string;
  url: string;
  icon: ReactElement;
  followers: string;
}

export const SocialCounter: FunctionComponent<SocialCounterProps> = (props) => {
  const classes = useStyles();

  return (
    <a
      className={classes.anchor}
      target="_blank"
      rel="noopener"
      href={props.url}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <IconButton className={classes.button} aria-label={props.label}>
          {props.icon}
        </IconButton>
        <Typography variant="body2" color="textSecondary">
          {props.followers}
        </Typography>
      </Box>
    </a>
  );
};

export default SocialCounter;
